import { Menu, Moon, Sun } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { Button } from '@/components/ui';
import { useTheme } from '@/context/ThemeContext';
import { appConfig } from '@/config';
import { ROUTES } from '@/constants';

const PAGE_TITLES = {
  [ROUTES.DASHBOARD]: 'Dashboard',
  [ROUTES.GERAR_ATA]: 'Gerar ata',
};

export function Header({ onOpenMobileSidebar }) {
  const { theme, toggleTheme } = useTheme();
  const { pathname } = useLocation();
  const pageTitle = PAGE_TITLES[pathname] || appConfig.appName;

  return (
    <header className="sticky top-0 z-30 flex h-[var(--header-height)] items-center justify-between gap-3 border-b border-[var(--border)] bg-[var(--card)]/90 px-4 backdrop-blur">
      <div className="flex items-center gap-2">
        <Button
          variant="ghost"
          size="icon"
          className="lg:hidden"
          onClick={onOpenMobileSidebar}
          aria-label="Abrir menu"
        >
          <Menu size={18} />
        </Button>
        <p className="text-sm font-medium text-[var(--foreground)]">{pageTitle}</p>
      </div>
      <div className="flex items-center gap-2">
        <Button
          variant="ghost"
          size="icon"
          onClick={toggleTheme}
          aria-label={theme === 'dark' ? 'Ativar tema claro' : 'Ativar tema escuro'}
        >
          {theme === 'dark' ? <Sun size={18} /> : <Moon size={18} />}
        </Button>
      </div>
    </header>
  );
}
